module.exports = __webpack_public_path__ + "static/img/success13.38f7d249.png";